
export function useComponentStylingType6() {
   
    const data = {             
        classStringTextDefault:"text-type-5 py-2",     
          };

 
  return data;
}